<div
  #container
  class="pill-multiselect"
  (click)="onContainerClick($event)"
>
  @for (item of selected; track item.key) {
    <motn-pill fill="solid" color="violet" [removable]="true" (remove)="removeItem(item)">{{ item.label }}</motn-pill>
  }

  <ng-content></ng-content>

  @if (showError && errorMsgInline) {
    <div class="error-message">
      {{ errorMsg }}
      <motn-info-circle [message]="errorInfoMsg"></motn-info-circle>
    </div>
  }
</div>

@if (menuOpen) {
  <motn-popover-multi-select
    [optionGroup]="optionGroup"
    (clickedOption$)="onPopoverOptionClicked($event)"
    (clickedOutsideMenu$)="closeMenu()"
  ></motn-popover-multi-select>
}
